<script>
import { onMount } from 'svelte';
import { getSchedule } from './services';
import { minuteOnMinuteInterval } from './util';
import { Link } from 'svelte-navigator';
import SummaryBox from './SummaryBox.svelte';
import EventCard from './EventCard.svelte';
import Countdown from './Countdown.svelte';
import { updateEventState } from './events';
import { ShowAllEventsOnShowOver } from './features';

const StateLoading = -1;
const StateUpcoming = 0;
const StateNow = 1;
const StateShowEnded = 2;
const StateShowEndedViewPast = 3;

let refreshTimer;
let events = [];
let renderedEvents = [];
let state = StateLoading;
let countdownTargetTime;

let sectionText;

const sectionTextMapping = {
  [StateUpcoming]: 'NEXT SESSIONS',
  [StateNow]: 'CURRENTLY LIVE SESSIONS',
  [StateShowEnded]: 'NO UPCOMING SESSIONS',
  [StateShowEndedViewPast]: 'PAST EVENTS',
}

$: sectionText = sectionTextMapping[state] || ''

function updateSchedule() {
  const now = new Date();
  events = updateEventState(events, now)
  
  // Note: Events are already sorted
  const nowOrFutureEvents = events.filter(event => now < event.endTime)
  
  if (nowOrFutureEvents.length === 0) {
    // Show's over

    if (ShowAllEventsOnShowOver) {
      state = StateShowEndedViewPast;
      renderedEvents = events;
    } else {
      state = StateShowEnded;
      renderedEvents = []
    }
    
    refreshTimer.unsubscribe()
    return;
  }

  // Get events happening now
  const nowEvents = nowOrFutureEvents.filter(event => event.startTime <= now)
  if (nowEvents.length > 0) {
    state = StateNow;
    renderedEvents = nowEvents;
    return;
  }

  // Upcoming shows that start at the same time
  const first = nowOrFutureEvents.slice(0, 1)[0]
  const startTimestamp = first.startTime.getTime();
  const upcomingEvents = nowOrFutureEvents.filter(event => event.startTime.getTime() === startTimestamp)
  const nowTs = now.getTime();

  state = StateUpcoming;
  renderedEvents = upcomingEvents;
  countdownTargetTime = first.startTime;
}

onMount(() => {
  (async () => {
    events = await getSchedule();
    updateSchedule();
  })();

  refreshTimer = minuteOnMinuteInterval().subscribe(updateSchedule);
  return () => refreshTimer.unsubscribe()
})

</script>

<div class="section-header">MAIN STAGE</div>

<div class="box col vcenter">
  {#if state === StateLoading}
    
       <div class="title">Walking to stage...</div>

  {:else if state === StateUpcoming}

      <div class="title mb-8">upcoming sessions</div>

      <div class="countdown">
        <span>Live in&hairsp;</span>
        <Countdown endTime={countdownTargetTime} />
      </div>

  {:else if state === StateNow}
      
      <div class="title">1H23 Digital Conference Has Begun</div>

      <!-- <div class="desc mt-8">Please click the "join" button to join the session in progress.</div> -->

  {:else if state === StateShowEnded || state === StateShowEndedViewPast}

      <div class="title">1H23 Digital Conference Has Ended</div>
      <!-- <div class="desc mt-8">There are no upcoming sessions, click the link below to view the full schedule and replay sessions that have already occurred.</div> -->

  {/if}

  <!-- <Link to="/schedule">
    <div class="button live schedule-button">GO TO MY SCHEDULE!</div>
  </Link> -->
</div>

<div class="section-header">{sectionText}</div>

{#each renderedEvents as event (event.id)}
  <EventCard {...event} />
{/each}

<style lang="scss">
@import './util';
.box {
  padding: 24px 24px;
  margin-bottom: 32px;
  background-image: url('/img/stage-header.jpg');
  background-size: cover;
  background-position: center;
  min-height: 182px;
}

.schedule-button {
  background-color: var(--guardsmen-red);
  color: white;
}

.title {
  text-transform: uppercase;
  font-size: 32px;
  color: white;
  font-weight: bold;
}

.desc {
  font-size: 16px;
  color: white;
}

.countdown {
  font-size: 40px;
  font-weight: bold;
  color: white;

  @include landscape {
    font-size: 26px;
  }

  @include mobile {
    font-size: 20px;
  }
}
</style>